module.exports = __webpack_public_path__ + "assets/media/mini_delete_category_icon.4c0b8619.svg";